(() => {
  const targetButtons = new Set(['claim with shop', 'get 20% off']);
  const targetPlaceholders = new Set([
    'first name',
    'last name',
    'email',
    'mobile phone number'
  ]);

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const styleForms = (root) => {
    if (!root || !root.querySelectorAll) return;

    const buttons = [...root.querySelectorAll('button')];
    const inputs = [...root.querySelectorAll('input, select, textarea, [role="combobox"]')];

    const hasTargetButton = buttons.some((button) => targetButtons.has(normalize(button.textContent)));
    const hasTargetField = inputs.some((field) => targetPlaceholders.has(normalize(field.getAttribute?.('placeholder'))));

    if (hasTargetButton || hasTargetField) {
      root.querySelectorAll('button, input, select, textarea, [role="combobox"]').forEach((element) => {
        element.style.setProperty('border-radius', '0px', 'important');
      });

      buttons.forEach((button) => {
        const label = normalize(button.textContent);

        if (targetButtons.has(label)) {
          button.style.setProperty('border-radius', '0px', 'important');
        }

        if (label === 'get 20% off') {
          button.style.setProperty('font-weight', '700', 'important');
        }
      });
    }

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) observeRoot(element.shadowRoot);
    });
  };

  const observeRoot = (root) => {
    if (!root || root.__rcFormsObserved) return;

    styleForms(root);

    const observer = new MutationObserver(() => styleForms(root));
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'class', 'style']
    });

    Object.defineProperty(root, '__rcFormsObserved', {
      value: true,
      configurable: true
    });
  };

  const scanDocument = () => styleForms(document);

  scanDocument();

  const documentObserver = new MutationObserver(scanDocument);
  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanDocument, { once: true });
  }
})();